import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

import { ProgressBarColor } from './progress-bar-color';

@Component({
  selector: 'atx-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProgressBarComponent {
  @HostBinding('class.progress')
  public progressClass = true;

  /** Maximum value of the progress bar */
  @Input() public max: number;
  /** Current value */
  @Input() public value: number;
  /** Color for the progress bar */
  @Input()
  public color: ProgressBarColor | string = ProgressBarColor.PRIMARY;

  /**
   * Returns the value for the progress bar, calculated with max and value
   */
  public get progress() {
    if (this.value && this.max) {
      return `${(100 * this.value) / this.max}%`;
    }
    return 0;
  }

  /**
   * Returns the class to be used to assign the color to the progress bar.
   * It uses bootstrap colors
   */
  public get colorClass() {
    if (
      !Object.values(ProgressBarColor).includes(this.color as ProgressBarColor)
    ) {
      return this.color;
    }

    return `bg-${this.color}`;
  }
}
